import React, { useEffect, forwardRef, useImperativeHandle, useState } from 'react';
import { Form, Input, DatePicker, message, Row, Col, Button } from 'antd';
import ApiServices from '~services';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '~commons/constants';
import fieldData from './fields-data';
import Utils from '~commons/utils';
import { UploadFile } from '~components/upload-file';
import checkContNumber from '~commons/check-cont-number';
import { Selection } from '~components';

const initDataForm = fieldData({});
export const FormInput = forwardRef(({ dataInput, reload, onClose }, ref) => {
  const [fields, setFields] = useState(initDataForm);
  const [locations, setLocations] = useState([]);

  const [form] = Form.useForm();
  useImperativeHandle(ref, () => ({
    submitForm() {
      form.submit();
    },
  }));

  const getLocations = async (Query = '') => {
    try {
      const res = await ApiServices.getLocations({
        companyId: dataInput?.companyId,
        Columns: { typeLocationName: 'cảng', name: Query },
      });
      if (res?.data?.data) {
        setLocations(res?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getLocations();
  }, [dataInput]);

  const initData = () => {
    // dataInput
    if (!dataInput) {
      setFields(initDataForm);
      return;
    }
    setFields(fieldData(dataInput));
  };
  useEffect(() => {
    initData();
  }, [dataInput]);

  const validateCheckContNumber = async (_, text) => {
    if (!text) return;
    try {
      const waitMe = () =>
        new Promise((resolve, reject) => {
          const check = checkContNumber(text);
          if (check) {
            resolve();
          } else {
            reject();
          }
        });
      await waitMe();
    } catch (error) {
      return Promise.reject(new Error('Số Cont không hợp lệ !!!'));
    }
  };

  const onSubmitForm = (value) => {
    const locationSelected = locations?.find((item) => item?.id === value?.locationId);
    if (locationSelected) {
      value.locationName = locationSelected?.name;
    } else {
      value.locationName = '';
    }

    delete value.book_CutOffDateTime;
    delete value.book_SIDateTime;
    value.pickupAcctualDate = value?.deliveryAcctualDate;
    const res = Utils.formatContData(value);
    let contFiles = [];
    let uploadFiles = [];
    for (let file of value.contFiles) {
      if (file?.originFileObj) {
        uploadFiles.push(file);
        continue;
      }
      contFiles.push(file);
    }
    ApiServices.updateBookingCont(dataInput.id, {
      ...res,
      contFiles: contFiles ? contFiles : [],
      files: uploadFiles,
    })
      .then((res) => {
        if (res?.status === 200) {
          message.success('Cập nhật thành công');
          reload();
          onClose && onClose();
        }
      })
      .catch((err) => {
        console.error('ERR - Update Booking Cont', err);
        message.error('Cập nhật thất bại');
      })
      .finally(() => {});
  };

  const showNote = (value, index) => {
    return (
      <div
        key={index}
        style={{
          fontSize: '14px',
          color: 'blue',
        }}
      >
        ** {value}
      </div>
    );
  };

  const renderNote = (value) => {
    if (!value) return '';
    const splitNote = value.split(';');
    if (splitNote?.length) {
      return splitNote?.map(showNote);
    } else {
      return <span>{value === 'null' ? '' : value}</span>;
    }
  };

  return (
    <>
      <Form
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 16,
        }}
        // labelAlign='left'
        form={form}
        layout='horizontal'
        name='global_state'
        className='form-booking'
        onFinish={onSubmitForm}
        fields={fields}
        onFieldsChange={(_, allFields) => {
          setFields(allFields);
        }}
      >
        <Form.Item name='customerName' label='Khách hàng'>
          <Input placeholder='Khách hàng' disabled />
        </Form.Item>
        <Form.Item name='subnoNumber' label='Số subNo'>
          <Input placeholder='subNo' disabled />
        </Form.Item>
        <Form.Item
          name='contNumber'
          label='Số Cont'
          rules={[
            // {
            //   required: true,
            //   message: 'Bạn phải nhập số Cont',
            // },
            {
              validator: validateCheckContNumber,
            },
          ]}
        >
          <Input placeholder='Số cont' />
        </Form.Item>
        <Form.Item name='sealNumber' label='Số Seal'>
          <Input placeholder='Số Seal' />
        </Form.Item>
        {dataInput?.onlyView ? (
          <></>
        ) : (
          <Form.Item
            wrapperCol={{
              offset: 10,
              span: 16,
            }}
            className='submit-form-input-data'
          >
            <Button
              style={{
                padding: '0px 40px',
              }}
              type='primary'
              htmlType='submit'
            >
              Lưu
            </Button>
          </Form.Item>
        )}

        <Form.Item
          name='locationId'
          label='Địa điểm LR'
          // rules={[
          //   {
          //     required: true,
          //     message: 'Bạn phải chọn Địa điểm LR',
          //   },
          // ]}
        >
          <Selection
            labelDefault={
              dataInput?.book_LocationDepotFromName ? dataInput?.book_LocationDepotFromName : ''
            }
            data={locations}
            placeholder='Địa điểm LR'
            fieldValue='name'
            onSearch={getLocations}
          />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              name='book_CutOffDateTime'
              label='Ngày giờ CM'
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                placeholder='Giờ cắt máng'
                disabled
                showHour
                format={DATE_TIME_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 9,
              }}
              wrapperCol={{
                span: 16,
              }}
              name='book_SIDateTime'
              label='Ngày giờ Cắt SI'
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                placeholder='Ngày Giờ SI'
                disabled
                showHour
                format={DATE_TIME_FORMAT}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              name='book_DeliveryContRequestDate'
              label='Ngày YCGC'
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                disabled
                placeholder='Ngày YCGC'
                format={DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 9,
              }}
              wrapperCol={{
                span: 16,
              }}
              name='book_LiftingEmptyContAcctualDate'
              label='Ngày Thực tế LR'
              // rules={[
              //   {
              //     required: true,
              //     message: 'Bạn phải nhập Ngày Thực tế LR',
              //   },
              // ]}
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                placeholder='Ngày Thực tế Lấy Rỗng'
                format={DATE_FORMAT}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              name='cutRomoocEmptyCont'
              label='Ngày Thực tế GR'
              // rules={[
              //   {
              //     required: true,
              //     message: 'Bạn phải nhập Ngày Thực tế GR',
              //   },
              // ]}
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                placeholder='Ngày Thực tế GR'
                format={DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {/* <Form.Item
              labelCol={{
                span: 9,
              }}
              wrapperCol={{
                span: 16,
              }}
              name='pickupAcctualDate'
              label='Ngày Thực tế LH'
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                placeholder='Ngày Thực tế Lấy Hàng'
                format={DATE_FORMAT}
              />
            </Form.Item> */}
            <Form.Item
              labelCol={{
                span: 9,
              }}
              wrapperCol={{
                span: 16,
              }}
              name='deliveryAcctualDate'
              label='Ngày TT Hạ Bãi Xuất'
              // rules={[
              //   {
              //     required: true,
              //     message: 'Bạn phải nhập Ngày TT Hạ Bãi Xuất',
              //   },
              // ]}
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                placeholder='Ngày TT Hạ Bãi Xuất'
                format={DATE_FORMAT}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name='note'
              label='Ghi chú KH'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
            >
              {renderNote(dataInput?.note)}
              {/* <Input.TextArea rows={2} disabled placeholder='Ghi chú khách hàng' /> */}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name='notePlan'
              label='Ghi chú xe ngoài'
              labelCol={{
                span: 9,
              }}
              wrapperCol={{
                span: 16,
              }}
            >
              <Input.TextArea rows={2} placeholder='Ghi chú xe ngoài' />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name='contFiles' label='File Đính Kèm'>
          <UploadFile showUpdated />
        </Form.Item>
      </Form>
    </>
  );
});
